import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { Store } from '@ngrx/store'
import { AppState } from './store'
import { setCurrentClient } from './store/broker/broker.actions'
import {
  toggleDarkTheme,
  toggleThemeChrome,
  toggleThemeLayerWireframe,
  toggleThemeLogoColor,
  toggleThemeUserCard,
} from './store/theme/theme.actions'

/**
 * App programatically interacting with the app through the browser development
 * tools.
 *
 * For instance, in the console, type `appDebug.toggleThemeDark()` to
 * dispatch the action that toggles the theme's dark mode.
 */
@Component({
  selector: 'app-debug',
  template: ``,
})
export class DebugContainerComponent implements OnInit {
  constructor(
    private store: Store<AppState>,
    private router: Router,
  ) {}

  ngOnInit() {
    const _window = window as any
    _window.appDebug = {
      getStore: () =>
        this.store.subscribe((s) => {
          _window.appDebug.store = s
          return s
        }),
      toggleThemeDark: () => this.store.dispatch(toggleDarkTheme()),
      toggleThemeChrome: () => this.store.dispatch(toggleThemeChrome()),
      toggleThemeLayerWireframe: () => this.store.dispatch(toggleThemeLayerWireframe()),
      toggleThemeUserCard: () => this.store.dispatch(toggleThemeUserCard()),
      toggleThemeLogoColor: () => this.store.dispatch(toggleThemeLogoColor()),
      testGroups: (id?: number) => {
        this.store.dispatch(setCurrentClient({ id: '3' }))
        this.router.navigate(['/analysis', 'group'])
      },
      testGroupPrograms: () => {
        this.store.dispatch(setCurrentClient({ id: '3' }))
        this.router.navigate(['/analysis', 'group'])
      },
      testCompare: () => {
        this.store.dispatch(setCurrentClient({ id: '3' }))
        this.router.navigate(['/analysis', 'compare'])
      },
      testCompare1: () => {
        this.store.dispatch(setCurrentClient({ id: '3' }))
        this.router.navigate(['/analysis', 'compare'])
      },
      testCompare3: () => {
        this.store.dispatch(setCurrentClient({ id: '3' }))
        this.router.navigate(['/analysis', 'compare'])
      },
    }
  }
}
